import React from "react";
import { useHistory } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownItem } from "reactstrap";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import CapsuleEditButton from "./CapsuleEditButton/CapsuleEditButton";
import CapsuleDeleteButton from "./CapsuleDeleteButton/CapsuleDeleteButton";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import {
    CAPSULE_DELETE_PERMISSION,
    CAPSULE_UPDATE_PERMISSION,
    KNOWLEDGE_BASE_READ_PERMISSION,
} from "components/dashboard/KnowledgeBase/permissions";
import "./CapsuleActionDropdown.scss";

const CapsuleActionDropdown = ({
    children,
    hasChildren,
    hasContent,
    capsule,
    contentId,
    content,
    productId,
    handleToggleEditModal,
    handleToggleDeleteModal,
    useCapsuleStyles,
    hideEditAction,
    hideDeleteAction,
    viewCapsuleOnly,
    capsuleBottomMenu,
}) => {
    // viewCapsuleOnly
    const [dropdownOpen, toggle] = React.useState(false);
    const history = useHistory();

    const handleRedirect = () => {
        history.push({
            pathname: `/knowledge-base/capsule/${productId}/${contentId}`,
            state: {
                capsule,
                contentId,
                content,
                productId,
            },
        });
    };

    return (
        <Dropdown
            isOpen={dropdownOpen}
            className={`${
                hasContent ? "capsule__content--tag mb-2" : "mainCapsule"
            }`}
            style={
                useCapsuleStyles
                    ? {
                          color: capsule?.borderColor,
                          borderColor: capsule?.borderColor,
                          background: "#fff",
                      }
                    : {}
            }
            direction='up'
            toggle={() => toggle((prevState) => !prevState)}>
            {hasChildren ? (
                <div onClick={() => toggle(true)}>{children}</div>
            ) : (
                <div className='d-flex align-items-center'>
                    <span
                        className='carbon__menu--icon'
                        onClick={() => toggle((prevState) => !prevState)}>
                        <ReactSVG src={asset?.icons?.carbonMore} />
                    </span>
                    <p class='main__content'>{content}</p>
                </div>
            )}
            <DropdownMenu
                className={`${
                    capsuleBottomMenu ? "capsule__bottom__menu" : ""
                }`}>
                {!hideEditAction && (
                    <ComponentAccessControl
                        baseResources={CAPSULE_UPDATE_PERMISSION}>
                        <CapsuleEditButton
                            contentId={contentId}
                            content={content}
                            capsule={capsule}
                            handleToggleEditModal={handleToggleEditModal}
                            hasChildren={hasChildren}
                        />
                    </ComponentAccessControl>
                )}
                {!hideDeleteAction && (
                    <ComponentAccessControl
                        baseResources={CAPSULE_DELETE_PERMISSION}>
                        <CapsuleDeleteButton
                            contentId={contentId}
                            capsule={capsule}
                            content={content}
                            handleToggleDeleteModal={handleToggleDeleteModal}
                            hasChildren={hasChildren}
                        />
                    </ComponentAccessControl>
                )}
                <ComponentAccessControl
                    baseResources={KNOWLEDGE_BASE_READ_PERMISSION}>
                    <DropdownItem onClick={handleRedirect}>View</DropdownItem>
                </ComponentAccessControl>
            </DropdownMenu>
        </Dropdown>
    );
};

export default CapsuleActionDropdown;
